import React from 'react';
import InfoTooltip from 'shared/components/info-tooltip';
import CostComparisonWithAverage from './cost-comparison-with-average';
import {NationalCollegeData} from 'src/types/college-profile';

interface Props {
  college: {
    typicalMonthlyStudentLoanPayment?: number;
  };
  nationalCollegeData: NationalCollegeData;
}

const CompareLoanPayment = ({college, nationalCollegeData}: Props) => {
  if (!college.typicalMonthlyStudentLoanPayment) {
    return null;
  }

  const loanTooltip = (
    <InfoTooltip className="college-profile-tooltip">
      The median monthly loan payment for student borrowers who completed, if it were repaid over 10
      years at a 4.45% interest rate. The national average is for borrowers aged 20 to 30, via
      StudentLoanHero.
    </InfoTooltip>
  );

  return (
    <CostComparisonWithAverage
      label="Average Monthly Loan Payment"
      tooltip={loanTooltip}
      dataSource={nationalCollegeData}
      attributeInSource="typicalMonthlyStudentLoanPayment"
      attributeOnCollege="typicalMonthlyStudentLoanPayment"
      college={college}
    />
  );
};

export default CompareLoanPayment;
